var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_5299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0.5H5C2.51472 0.5 0.5 2.51472 0.5 5V40C0.5 42.4853 2.51472 44.5 5 44.5H40C42.4853 44.5 44.5 42.4853 44.5 40V5C44.5 2.51472 42.4853 0.5 40 0.5Z",
    stroke: "#34384C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0848 13C19.2614 13 16.9792 15.2822 16.9792 18.1072V20.2336H15.2768C14.5764 20.2336 14 20.8117 14 21.5104V31.7249C14 32.4236 14.5764 33 15.2768 33H28.8944C29.5932 33 30.1712 32.4236 30.1712 31.7249V21.5104C30.1712 20.8117 29.5932 20.2336 28.8944 20.2336H27.192V18.1072C27.192 15.2822 24.9099 13 22.0848 13ZM22.0848 13.8512C24.4541 13.8512 26.3408 15.7379 26.3408 18.1072V20.2336H17.8304V18.1072C17.8304 15.7379 19.7172 13.8512 22.0848 13.8512ZM15.2768 21.0848H28.8944C29.1307 21.0848 29.32 21.2741 29.32 21.5104V31.7249C29.32 31.9594 29.1307 32.1488 28.8944 32.1488H15.2768C15.0405 32.1488 14.8512 31.9594 14.8512 31.7249V21.5104C14.8512 21.2741 15.0405 21.0848 15.2768 21.0848ZM22.0848 24.4896C21.3626 24.4896 20.808 25.0426 20.808 25.7664C20.808 26.1485 20.9772 26.4853 21.2336 26.6981V27.8944C21.2336 28.3636 21.6156 28.7456 22.0848 28.7456C22.554 28.7456 22.936 28.3636 22.936 27.8944V26.6981C23.1924 26.4853 23.3616 26.1485 23.3616 25.7664C23.3616 25.0426 22.8086 24.4896 22.0848 24.4896Z",
    fill: "#0074FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_5299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalLocked);
export default __webpack_public_path__ + "static/media/total_locked.cd81e006139ca313316f0ca63cc9c89f.svg";
export { ForwardRef as ReactComponent };